import { sendRequest } from "../base.service";

export const getNewsList = () => {
  return sendRequest("/home/news");
};
export const getVSATNewsList = () => {
  return sendRequest("/vsat/news");
};
export const getRetiredNewsList = () => {
  return sendRequest("/retired/news");
};
export const getPartnersNewsList = () => {
  return sendRequest("/partner/news");
};

export const getNewsRelatedList = (id, categoryId) => {
  let url = "/news/related/" + id;
  for (let i = 0; i < categoryId.length; ++i) {
    if (url.indexOf("?") === -1) {
      url = url + "?category[]=" + categoryId[i];
    } else {
      url = url + "&category[]=" + categoryId[i];
    }
  }
  return sendRequest(url);
};
export const getSahamRelatedNewsList = (id, categoryId) => {
  let url = "/news/related/sahamdaran/" + id;
  for (let i = 0; i < categoryId.length; ++i) {
    if (url.indexOf("?") === -1) {
      url = url + "?category[]=" + categoryId[i];
    } else {
      url = url + "&category[]=" + categoryId[i];
    }
  }
  return sendRequest(url);
};

export const getSingleNews = (id) => {
  return sendRequest("/news/" + id);
};
export const getNewsFileToDownload = (id) => {
  return sendRequest("/home/itNews/download", "post", { id: id });
};
export const getArticleFileToDownload = (id) => {
  return sendRequest("/home/article/download", "post", { id: id });
};
export const getNewsPaginationList = (page) => {
  return sendRequest("/news/page", "post", { page: page });
};
export const getTradePaginationList = (page) => {
  return sendRequest("/trade/page", "post", { page: page });
};
export const getSearchTrade = (page, q) => {
  return sendRequest("/trade/search", "post", { q, page });
};
export const getRetiredNewsPaginationList = (page) => {
  return sendRequest("/news/retired/page/", "post", { page: page });
};

export const getVSATNewsPaginationList = (page) => {
  return sendRequest("/news/vsat/page", "post", { page: page });
};

export const getPartnersNewsPaginationList = (page) => {
  return sendRequest("/news/partner/page", "post", { page: page });
};

export const getSearchNews = (page, q) => {
  return sendRequest("/news/search", "post", { page, q });
};

export const getVSATSearchNews = (page, q) => {
  return sendRequest("/news/vsat/search", "post", { page, q });
};

export const getPartnerSearchNews = (page, q) => {
  return sendRequest("/news/partner/search", "post", { page, q });
};

export const getRetiredSearchNews = (page, q) => {
  return sendRequest("/news/retired/search", "post", { page, q });
};

export const getSearchArticles = (q) => {
  return sendRequest("/article/search", "post", { q });
};

export const getITNews = () => {
  return sendRequest("/home/it-news");
};
export const getAnnouncementList = () => {
  return sendRequest("/home/announcement");
};
export const getMultiMediaList = () => {
  return sendRequest("/home/multimedia");
};

export const getArticles = () => {
  return sendRequest("/home/article");
};
